import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Palette } from 'Palette';

interface StyledFieldDescriptionProps {
  stacked?: boolean;
}

const StyledFieldDescription = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'stacked',
})<StyledFieldDescriptionProps>(({ stacked }) => ({
  fontSize: '0.875rem',
  marginLeft: stacked ? 0 : '140px',
  marginTop: stacked ? '0.25rem' : '-0.25rem',
  marginBottom: '0.5rem',
  color: Palette.default.inactiveOrCancelButtonText,
}));

export default StyledFieldDescription;
